<template>
	<span>
		<i :class="classes" :data-icon="icon" :data-prefix="library"></i>
	</span>
</template>

<script>
export default {
	name: "DcIcon",
	props: {
		fixedWidth: {
			type: Boolean,
			default: false
		},
		icon: {
			type: String,
			default: () => null
		},
		library: {
			type: String,
			default: () => "fal"
		},
		noMargin: {
			type: Boolean,
			default: false
		},
		leftMargin: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: () => null
		},
		spin: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		classes() {
			return [
				this.library,
				`fa-${this.icon}`,
				this.size ? `fa-${this.size}` : ``,
				!this.noMargin ? `has-margin` : ``,
				this.leftMargin ? `left-margin` : ``,
				this.spin ? `fa-spin` : ``,
				this.fixedWidth ? `fa-fw` : ``
			];
		}
	},
	watch: {
		icon(icon) {
			const element = this.$el.querySelector("svg");
			if (element) {
				element.setAttribute("data-icon", icon);
			}
		},
		library(library) {
			const element = this.$el.querySelector("svg");
			if (element) {
				element.setAttribute("data-prefix", library);
			}
		}
	}
};
</script>

<style scoped>
.has-margin {
	margin-right: 0.5em;
}
.left-margin {
	margin-left: 0.5em;
}
</style>
